import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { parseHtml } from "@components/HTMLParser/utils";
import { useI18nStore } from "@store/i18n/i18nStore";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { useGetPlanRulesQuery } from "@services/planRules/queries";

interface IMaxPlanRulesContentProps {
  jointBillServicePlanId: PlanId;
}

export const MaxPlanRulesContent: React.FC<IMaxPlanRulesContentProps> = (
  props,
) => {
  const { jointBillServicePlanId } = props;
  const { t } = useTranslation();
  const { locale } = useI18nStore();
  const { data } = useGetPlanRulesQuery(locale);

  const getRules = useCallback(
    (jointBillServicePlanId: PlanId) => {
      const rules = data?.find(
        (rules) =>
          rules.jointBillServicePlanId === jointBillServicePlanId.toString(),
      );

      return parseHtml((rules?.Content ?? "") + (rules?.Files ?? ""));
    },
    [data],
  );

  return (
    <div className="flex flex-col gap-5 overflow-y-auto lg:h-[60vh]">
      {jointBillServicePlanId == PlanId.MAX && (
        <h4>{t(`planMaxDocumentation.${PlanId.MCI}.title`)}</h4>
      )}
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MCI) &&
        getRules(PlanId.MCI)}
      {jointBillServicePlanId == PlanId.MAX && (
        <h4>{t(`planMaxDocumentation.${PlanId.MBI}.title`)}</h4>
      )}
      {(jointBillServicePlanId == PlanId.MAX ||
        jointBillServicePlanId === PlanId.MBI) &&
        getRules(PlanId.MBI)}
    </div>
  );
};
